import { render } from "./applicationDetails.vue?vue&type=template&id=984903d8"
import script from "./applicationDetails.vue?vue&type=script&lang=js"
export * from "./applicationDetails.vue?vue&type=script&lang=js"

import "./applicationDetails.vue?vue&type=style&index=0&id=984903d8&lang=less"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__